import React from "react";
import ModalNew from "../Modal/ModalNew";

interface PDFPreviewProps {
  fileUrl: string;
  isOpen: boolean;
  onClose: () => void;
}

const PDFPreview: React.FC<PDFPreviewProps> = ({ fileUrl, isOpen, onClose }) => {
  return (
    <ModalNew isOpen={isOpen} onClose={onClose} title="CV Preview" className="max-w-[800px] w-full">
      <div className="h-[80vh] w-full">
        <iframe
          src={fileUrl}
          className="w-full h-full rounded-lg"
          title="PDF Preview"
        />
      </div>
    </ModalNew>
  );
};

export default PDFPreview;
